export const PARTNER_API_DOCS_DEFAULT_PARAMETERS = [
    {
        name: 'partner_id',
        description: 'partner.api_docs.partner_id_description',
        type: 'partner.api_docs.integer',
    },
    {
        name: 'api_key',
        description: 'partner.api_docs.api_key_description',
        type: 'partner.api_docs.string',
    },
];
